import Typography from '@components/v2/ui/Typography/Typography';
import LangEnum from '../../../../../../../lang/LangEnum';
import { ProductDetailsTestIds } from '../../../../../../../utils/testIds/productDetails.testIds';
import { useTranslation } from '../../../../../../translation/TranslationContext';

interface CombinationLineUnavailableGridProps {
  gridLength: number;
}

const CombinationLineUnavailableGrid = ({ gridLength }: CombinationLineUnavailableGridProps) => {
  const { translate } = useTranslation();

  if (gridLength > 0) {
    return null;
  }

  return (
    <Typography
      noWrap
      variant="body2"
      color="textSecondary"
      testId={ProductDetailsTestIds.COMBINATION_UNAVAILABLE_GRID}
    >
      {translate(LangEnum.PRODUCT_DETAILS_UNAVAILABLE_GRID)}
    </Typography>
  );
};

export default CombinationLineUnavailableGrid;
